import { NextSeo } from 'next-seo';

//screens
import { DocumentCollectionAndFiling } from '@/screens/Agents/DocumentCollectionAndFiling';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function DocumentCollectionAndFilingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/document-collection-and-filing/"
        title="Document Collection & Filing Agent | Loadsmart AI"
        description="Every quote, tender, rate confirmation, BOL, POD and invoice — captured as it arrives, classified, and filed against the right shipment."
        openGraph={{
          url: 'https://loadsmart.com/ai/document-collection-and-filing/',
        }}
      />
      <JsonLd data={Organization} />
      <DocumentCollectionAndFiling />
    </>
  );
}
